import DestekService from "../../../services/DestekService";

export default {
  namespaced: true,
  state: () => ({
    destekTalepleri: [],
    destekTalepleriSayisi: 0,
  }),
  mutations: {
    setDestekTalepleri: (state, data) => {
      state.destekTalepleri = data;
    },
    setDestekTalepleriSayisi: (state, data) => {
      state.destekTalepleriSayisi = data;
    },
  },
  actions: {
    destekTalepleri: ({ commit }, data) => {
      commit("setDestekTalepleri", []);
      commit("setDestekTalepleriSayisi", 0);
      return new Promise((resolve, reject) => {
        DestekService.destekTalepleri(data)
          .then((res) => {
            commit("setDestekTalepleri", res.data.list);
            commit("setDestekTalepleriSayisi", parseInt(res.data.count));
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
